//
//
//
//
//
//
//
//
var script = {
  props: {
    appearance: {
      type: String,
      validator: value => ['default', 'success', 'removed', 'inprogress', 'new', 'moved'].includes(value),
      default: 'default'
    },
    isBold: {
      type: Boolean,
      default: false
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Lozenge/Lozenge.vue_rollup-plugin-vue=script.js